import { createSlice } from "@reduxjs/toolkit";

const sourceDatas = {};

const SourceDataSlice = createSlice({
    name: "source",
    initialState: {
        sourceDatas,
    },
    reducers: {
        reSetSourceData(state,action){
            state.sourceDatas = {}
        },
        setSourceData(state, action) {
            state.sourceDatas = action.payload;
        },
    },
});


export const {
    setSourceData,
    reSetSourceData
} = SourceDataSlice.actions;

export default SourceDataSlice.reducer;
